export default "__VITE_PUBLIC_ASSET__8c1178e0__"